// The tool shell is prerendered; the validation runs client-side on the pasted
// MRZ, so this route keeps its default client rendering.
export const prerender = true;
